import * as Sentry from '@sentry/react';
import useUserData from 'FeatureModules/Auth/hooks/useUserData';
import React, { createContext, FC, PropsWithChildren, useEffect } from 'react';
import { useFirebase } from '../FeatureModules/Auth/Contexts/FirebaseContext';

const SentryContext = createContext<boolean | null>(null);

/**
 * Adds the current user data to the Sentry
 */
const SentryUserProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user, company } = useUserData();
  const { authenticated } = useFirebase();

  useEffect(() => {
    if (authenticated && user && company) {
      const { id, fullName, email } = user;
      Sentry.setUser(process.env.NODE_ENV === 'production' ? { id } : { id, fullName, email });
    }
  }, [user, company, authenticated]);

  return <SentryContext.Provider value={true}>{children}</SentryContext.Provider>;
};

export { SentryUserProvider };

export default SentryContext;
